import { api } from './index';

export default {
  getAbout(isValue = '') {
    return api.get(`/about_us_pages${isValue && '/values'}`);
  },
  getCompanyValueDetail(id) {
    return api.get(`/about_us_pages/values/${id}`);
  },
  createCompanyValue(payload) {
    return api.post('/about_us_pages/values', payload);
  },
  updateAbout(payload, id = '') {
    const additionalRoute = id && `/values/${id}`;

    return api.put(`/about_us_pages${additionalRoute}`, payload);
  },
  deleteCompanyValue(id) {
    return api.delete(`/about_us_pages/values/${id}/delete`);
  },
};
